import React from 'react';
import { Empty, Timeline, Typography } from 'antd';
import { humanizeStageKey } from '@/components/commercial-lifecycle/lifecycleStageView';
import type { PursuitLineageNode } from './pursuitWorkspaceModel';

const { Text } = Typography;

export type PursuitActivityTimelineProps = {
  nodes: PursuitLineageNode[];
  onNodeClick?: (node: PursuitLineageNode) => void;
};

/** Human-readable commercial lineage (not a duplicate audit store). */
export const PursuitActivityTimeline: React.FC<PursuitActivityTimelineProps> = ({
  nodes,
  onNodeClick,
}) => {
  if (!nodes.length) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="No lineage yet. Activity appears as the pursuit advances."
      />
    );
  }

  return (
    <Timeline
      items={nodes.map((n) => ({
        children: (
          <button
            type="button"
            onClick={() => onNodeClick?.(n)}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              textAlign: 'left',
              cursor: onNodeClick ? 'pointer' : 'default',
            }}
          >
            <Text strong>{humanizeStageKey(n.stageKey)}</Text>
            <br />
            <Text type="secondary" style={{ fontSize: 12 }}>
              {n.entityType} · {n.entityId.slice(0, 8)}…
              {n.revision != null ? ` · rev ${n.revision}` : ''}
            </Text>
          </button>
        ),
      }))}
    />
  );
};

export default PursuitActivityTimeline;
